export default "__VITE_ASSET__AlSPAmSC__"